module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/DavidDeco_bottom-d39a9a9457b4a25ef9c19596c83dac61.png";